var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInRight",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "enter-active-area": "animated fadeIn"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "text-center about-us-heading"
  }, [_vm._v("Who We Are")]), _vm._v(" "), _c('h5', {
    staticClass: "text-center"
  }, [_vm._v("Forum for Rural Infrastructural, Environmental & National Development Society (FRIENDS)")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-6 text-tile"
  }, [_c('h5', [_vm._v("Working With Our Mission")]), _vm._v(" "), _c('p', [_vm._v(" We are dedicated to promoting empowerment of people, protection of the environment, service to Humanity in health care & support and respect for cultural diversity. Our commitment lies in implementing governmental schemes with the help of\n          volunteer efforts so as to induce a significant change at the much needed grass roots levels of the society. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./About-pics/community-awareness.jpg"),
      "alt": "Helping create a better society"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./About-pics/chinese-doc.jpg"),
      "alt": "Pioneers in social service"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6 text-tile"
  }, [_c('h5', [_vm._v("Staying Focussed With Our Vision")]), _vm._v(" "), _c('p', [_vm._v("Our organization will distinguish itself as a pioneer in rendering social welfare services. It will further be recognized for the passion of its work in providing quality, innovative care to the betterment of all the communities it will be involved\n          with.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6 text-tile"
  }, [_c('h5', [_vm._v("Making a better society one friend at a time")]), _vm._v(" "), _c('p', [_vm._v("Formed in 2000, we are a Non-Governmental Organisation (NGO) based in Haridwar, Uttarakhand. Through our continuous involvement at the grass-root levels of the society, we have been successfully addressing the health related & socio-economic\n          needs of the deprived sections of our society. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./About-pics/doc-kid-ranjana.jpg"),
      "alt": "Making Friends"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./About-pics/doc-bp.jpg"),
      "alt": "Helping people in the slums"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6 text-tile"
  }, [_c('h5', [_vm._v("Healthcare and medical services for the slums")]), _vm._v(" "), _c('p', [_vm._v("With 15 years of experience, we have undertaken various projects targeting core issues of the urban slums like women & child development, social welfare, health & hygiene, family planning, Ante Natal Care (ANC), Post Natal Care (PNC) &\n          child immunization. We have further partnered on targeted intervention projects with focus on HIV AIDS. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6 text-tile"
  }, [_c('h5', [_vm._v("Dedicated and Well Trained Teams")]), _vm._v(" "), _c('p', [_vm._v("We have experienced teams of doctors, nurses, Auxiliary Nurse Midwifery (ANM's) and General Nursing and Midwifery (GNM's). Further supporting us are Accredited Social Health Activists (ASHA's) who help in organising camps and spreading the word.\n          Together, we have changed lives by bringing awareness on different health related issues. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./About-pics/our-team.jpg"),
      "alt": "Our People"
    }
  })])]), _vm._v(" "), _c('hr')])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7da17eb6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About/About.vue
// module id = ei30
// module chunks = 0